<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <div
    data-slot="sidebar-header"
    data-sidebar="header"
    :class="cn('h-14 flex flex-col gap-2 px-2 pt-4 pb-0 text-white', props.class)"
  >
    <slot />
  </div>
</template>
